import axios from '../../../../utils/request';
function GET_LIST(params) {
    return axios.get("/admin/AOption/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/admin/AOption/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.get("/admin/AOption/edit",{
        params: {
            ...params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/admin/AOption/editPost",{...params} )
}
function DELE(params) {
    return  axios.get("/admin/AOption/delete",{
        params: {
            ids:params
        }
    } )
}

export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    DELE
};